import React from 'react';
import { FunctionFactory } from 'survey-core';
import { Goals } from './goals';

const emailQuestion = {
  name: "email",
  title: "Your goal timeline is ready.",
  type: "text",
  // description: `<div class="disclaimer">
  // <div>We'll email you a copy of your results for convenient access.</div><br />
  // By clicking "See My Results" below you acknowledge that you have read, understood, and accepted the <span class="disclaimer__terms"><a href="https://builtwithscience.com/terms-of-use/" target="_blank">Terms of Use</a></span> and <span class="dislaimer__terms"><a href="https://builtwithscience.com/privacy-policy/" target="_blank">Privacy Policy</a></span>.  You may receive emails from Built With Science and can unsubscribe at any time.
  // </div>`,
  description: "Enter your email to see how long it will take to reach your goal.",
  inputType: "email",
  isRequired: true,
  placeholder: "Enter your email",
  autocomplete: "email",
};

const emailWeightGoalTextExpression = {
  name: "emailWeightGoalText",
  expression: "renderEmailWeightGoalTextExpression({weightGoal}, {goalBodyFat}, {muscleGain}, {goals})",
};

function renderEmailWeightGoalTextExpression(params: any[]): string {
  if (params === undefined || params === null) return "";
  // const weightRaw = params[0] as number;
  // const goalBodyFat = params[1] as BodyFat;
  // const muscleGain = params[2] as number;
  const goals = params[3] as Goals;

  switch (goals) {
    case Goals.LoseFat:
      return `weight loss`;
    case Goals.BuildMuscle:
      return `muscle gain`;
    case Goals.BuildMuscleAndLoseFat:
      return `fat loss`
  }
}

FunctionFactory.Instance.register("renderEmailWeightGoalTextExpression", renderEmailWeightGoalTextExpression);

const emailCopyElement = {
  name: 'email-copy',
  type: 'html',
  title: "asdfsdaf",
  html: `<div class="sd-element--with-frame" style="font-size: 12px; font-style: italic; color: #7A7A7A; text-align: center;">We’ll email you a copy of your results for convenient access.</div>`,
}

const emailDisclaimerElement = {
  name: 'email-copy',
  type: 'html',
  title: "asdfsdaf",
  html: `
    <div class="sd-element--with-frame" style="font-size: 12px; font-style: italic; color: #7A7A7A; margin-top: 50px; text-align: center;">
      By clicking “See My Results” below, you acknowledge that you have read, understood, and accepted the <span class="disclaimer__terms"><a href="https://builtwithscience.com/terms-of-use/" target="_blank">Terms of Use</a></span> and <span class="disclaimer__terms"><a href="https://builtwithscience.com/privacy-policy/" target="_blank">Privacy Policy</a></span>. You may receive emails from Built With Science and can unsubscribe at any time.
    </div>
  `,
}

const disclaimerElement = (
  <div style={{ marginBottom: "8px" }}>
    By clicking “See My Results” below, you acknowledge that you have read, understood, and accepted the <span className="disclaimer__terms"><a href="https://builtwithscience.com/terms-of-use/" target="_blank" rel="noreferrer">Terms of Use</a></span> and <span className="disclaimer__terms"><a href="https://builtwithscience.com/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a></span>. You may receive emails from Built With Science and can unsubscribe at any time.
  </div>
);

export {
  emailQuestion,
  emailCopyElement,
  emailDisclaimerElement,
  disclaimerElement,
  emailWeightGoalTextExpression,
};
